/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


  $(document).ready(function() {
  $(".set > a").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .siblings(".content1")
        .slideUp(200);
      $(".set > a i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
    } else {
      $(".set > a i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
      $(this)
        .find("i")
        .removeClass("fa-plus")
        .addClass("fa-minus");
      $(".set > a").removeClass("active");
      $(this).addClass("active");
      $(".content1").slideUp(200);
      $(this)
        .siblings(".content1")
        .slideDown(200);
    }
  });
});

function updateHeaderOnScroll() {
    var scroll = $(window).scrollTop();

    if (scroll >= 50) {
        $(".Header--withIcons").addClass("darkHeader");
        $(".Header").addClass("Header--scrolled");
    } else {
        $(".Header--withIcons").removeClass("darkHeader");
        $(".Header").removeClass("Header--scrolled");
    }
}

// Check on page load
$(document).ready(function() {
    updateHeaderOnScroll();
});

$(window).scroll(function() {    
    updateHeaderOnScroll();
});


  // Accepts any class name - only initialize if elements exist
  if (document.querySelector('.rellax')) {
    var rellax = new Rellax('.rellax');
    // Destroy and create again parallax with previous settings
    rellax.refresh();
  }

  if (document.querySelector('.rellax1')) {
    var rellax1 = new Rellax('.rellax1');
    rellax1.refresh();
  }
// ==============rellax end========

// Custom variant change handler for ProductMeta price update
document.addEventListener('DOMContentLoaded', function() {
  var variantSelect = document.querySelector('[data-variant-select]');
  var priceContainer = document.querySelector('.ProductMeta__PriceList');
  
  if (variantSelect && priceContainer) {
    variantSelect.addEventListener('change', function(e) {
      var selectedOption = e.target.options[e.target.selectedIndex];
      var priceText = selectedOption.getAttribute('data-price');
      
      if (priceText) {
        // Update the price display
        var priceElement = priceContainer.querySelector('.ProductMeta__Price');
        if (priceElement) {
          priceElement.textContent = priceText;
        }
      }
    });
  }
});
